import { UIComponentHandler, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { TunesViewImpl, TunePlaylistOptionPrivilageImpl } from './tunesview';
import { ListTonesDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/listtonesdto';
import { ToneDto, ToneDtoImpl } from '../../../../core/dto/tonedto';
import { CRBTUIComponentProps, CRBTUIComponent } from '../crbt/crbtuicomponent';
import { TunesAPIModelImpl, TunesAPIModel } from './tunesapimodel';
import { TunesCSSStyleImpl } from './tunescss';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ToneStatus } from '../../../toolkit/toneoptions/tone/tonestatus';


export interface TunesComponentProps extends CRBTUIComponentProps
{
    onPlaylistClick(playlistDto: ToneDto): void;
}

export interface TunesComponentHandler extends UIComponentHandler
{
    onShuffleStatus(isShuffleOn: boolean): void;
    onPlaylistSelected(playlistDto: ToneDto): void;
    onCloseTuneSettings(isSettingsClicked: boolean): void;
    onSuccessTuneSettings(isSettingsClicked: boolean): void;
    onTuneSettingsSelected(playlistDto: ToneDto): void;
    onLoadMore(title: string, startIndex: number, offset: number, searchKey: string): void;
}

export interface TunesComponentState extends UIComponentState
{
     isSettingsClicked: boolean;
     toneDto: ToneDto;
     status:any;
     shuffleStatus:boolean;
}

export interface TunesTabComponentHandler 
{
    
    onDeleteClicked(toneDto: ToneDto): void;
    onLoadMore(startIndex: number, offset: number, searchKey: string): void;
}

export class TunesComponent extends CRBTUIComponent<TunesComponentProps, TunesComponentState> 
implements TunesComponentHandler
{
    constructor(props: TunesComponentProps)
    {
        super(props);

        this.state = {isSettingsClicked: false, toneDto: new ToneDtoImpl(),shuffleStatus:false,status:ToneStatus.ACCEPTED};
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new TunesViewImpl(applicationContext, uiComponentHandler);
    }

    componentDidMount()
    {
        
        (this.getView() as TunesViewImpl).showLoader();
        (this.getAPIModel() as TunesAPIModel).getTunes();
        // (this.getAPIModel() as TunesAPIModel).getPlaylist();
        // (this.getAPIModel() as TunesAPIModel).getProfileTunes();
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new TunesCSSStyleImpl(applicationContext);
    }
    
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new TunesAPIModelImpl(applicationContext, apiModelHandler);
    }

    onLoadMore(title: string, startIndex: number, offset: number, searchKey: string): void 
    {
        // (this.getAPIModel() as TunesAPIModel).loadMore(startIndex, offset, searchKey);
    }

    onPlaylistSelected(playlistDto: ToneDto): void 
    {
        let toneDto = this.props.context.getToneContext();

        if(toneDto !== null)
        {
            toneDto.setId(playlistDto.getId());
            toneDto.setTonePrivilage(new TunePlaylistOptionPrivilageImpl());
          
            this.props.context.setToneContext(toneDto);
    
           this.props.onPlaylistClick(playlistDto);
        }
    }

    onCloseTuneSettings(isSettingsClicked: boolean): void
    {
        this.setState({isSettingsClicked: isSettingsClicked});
    }

    onShuffleStatus(isShuffleOn: boolean)
    {
        this.setState({shuffleStatus: isShuffleOn});
    }
    onSuccessTuneSettings(isSettingsClicked: boolean): void
    {
        this.setState({isSettingsClicked: isSettingsClicked}, ()=>
        {
            (this.getView() as TunesViewImpl).showLoader();
            (this.getAPIModel() as TunesAPIModel).getTunes();
        });
    }

    onTuneSettingsSelected(toneDto: ToneDto): void
    {
        this.setState({toneDto: toneDto, isSettingsClicked: true});
    }
    updateStatus(listToneDto: ToneDto[])
    {
        
       listToneDto.filter((toneDto: ToneDto)=>
        {
           
          let dto = (toneDto as ListTonesDto);
        //   let dto1 = (toneDto as ChildListTonesDto);
          console.log("shuffle flag",dto.getIsShuffle());
        //   if(dto1.getServiceName() === "AllCaller" && dto1.getIsShuffle() === "T")
        //   {
        //       console.log("shuffle flag");
        //     this.setState({shuffleStatus:true});
        //   }
          
          
         
          if(dto.getStatus() === ToneStatus.PENDING)
          {
            this.setState({status:ToneStatus.PENDING});
          }
        });
        // (this.profileTunes as TunesListTabViewModelImpl).updateTabData(listToneDto.filter((toneDto: ToneDto)=>
        // {
        //     return (toneDto as ListTonesDto).getIsStatusRBT();
        // }));
    }
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("---feature: " + feature);
    

        if(feature === APIFeatures.MYLIBRARY_TUNES)
        {
            (this.getView() as TunesViewImpl).dismissLoader();
            
          
            (this.getView() as TunesViewImpl).updateTonesData((data as ToneDto[]));
            this.updateStatus(data as ToneDto[]);
        }
        else 
        {
            console.log("settings playlist data: " + JSON.stringify((data as ToneDto[])));
            // (this.getView() as TunesViewImpl).updatePlaylistData((data as ToneDto[]));
        }

        window.scrollTo(0,0);
    }

    
    onFailure(feature: APIFeatures, description: string, data: any): void
    {
        if(feature === APIFeatures.MYLIBRARY_TUNES)
        {
            (this.getView() as TunesViewImpl).dismissLoader();
         
            if(this.props.context.getUserContext().getPackName() !== undefined)
            {
               
                (this.getView() as TunesViewImpl).showPopup(this.getContext().getResources().getString(Strings.no_tunes_available)
                ,AlertType.ERROR);
            }
            else
            {
            
                (this.getView() as TunesViewImpl).showPopup(this.getContext().getResources()
        .getString(Strings.your_not_active_rbt_subscriber),AlertType.ERROR);
            }
        }

        window.scrollTo(0,0);
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunes/tunescomponent.tsx